exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Header-default-rDovw{overflow:hidden;margin:0 0 20px;padding:10px;border:1px solid #dadada;border-radius:10px 10px 0 0;background:#fff}.Header-default-rDovw h3,.Header-default-rDovw h4,.Header-default-rDovw h5{margin:0;font-weight:400;text-transform:uppercase}.Header-default-rDovw h3 small,.Header-default-rDovw h4 small,.Header-default-rDovw h5 small{color:inherit}.Header-main-2sVxC{overflow:hidden;float:left;margin:5px 0 0}.Header-main-2sVxC .Header-container-k5YYq,.Header-main-2sVxC .Header-status-1rQT2{display:inline-block}.Header-side-35s1B{float:right}.Header-success-ssRSx{border-bottom:1px solid #00e5ce}.Header-warning-1EelI{border-bottom:1px solid #faad44}.Header-danger-fYp2m{border-bottom:1px solid #ff5766}", ""]);

// exports
exports.locals = {
	"default": "Header-default-rDovw",
	"main": "Header-main-2sVxC",
	"container": "Header-container-k5YYq",
	"status": "Header-status-1rQT2",
	"side": "Header-side-35s1B",
	"success": "Header-success-ssRSx",
	"warning": "Header-warning-1EelI",
	"danger": "Header-danger-fYp2m"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/Header.less
// module id = 1647
// module chunks = 0